import styled from "styled-components";
import Contact from "./LandingContact";
import useIsMobile from "@/hooks/useIsMobile";

const LandingFooter = () => {
  const isMobile = useIsMobile();
  return (
    <LandingFooterContainer className="landing__footer-container">
      <FooterItem $ismobile={isMobile}>
        <Contact />
      </FooterItem>
      {/* <FooterItem className="landing__footer-button">
        <LinkButton link="https://platform.spacemap42.com/">
          Platform Link
        </LinkButton>
      </FooterItem> */}
      <FooterItem $ismobile={isMobile}>
        <p>© 2021 SPACEMAP INC, All Rights Reserved.</p>
      </FooterItem>
    </LandingFooterContainer>
  );
};

export default LandingFooter;

const LandingFooterContainer = styled.footer`
  display: grid;
  grid-template-columns: 1fr 1fr;
  height: 100%;
`;

const FooterItem = styled.div`
  display: flex;
  justify-self: center;
  padding: ${props => (props.$ismobile ? "0 0.5rem" : "0 3rem")};
  align-items: end;
  &:first-child {
    justify-self: start;
  }
  &:last-child {
    justify-self: end;
  }
`;
